import {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import {ButtonProps, ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {getSuppliers} from '../core/_requests'
import {Supplier} from '../core/_models'
import {Columns} from './columns/_columns'
import {SupplierForm} from './components/SupplierForm'
import {FilterForm, initialFilters} from './components/FilterForm'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}])

/**
 * Toolbar buttons
 */
const buttons: Array<ButtonProps> = [{
  label: 'Add',
  className: 'btn btn-primary me-3',
  icon: {
    name: 'plus',
    className: 'fs-2'
  },
  openModal: 'add'
}]


/**
 * Modal wrapper to manage open modal
 */
const SupplierModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
  return (
    <>
      {itemForUpdate && action === 'edit' && (
        <Modal title={`Change ${(itemForUpdate as Supplier).name} status`}>
          <SupplierForm />
        </Modal>
      )}
      {itemForUpdate === null && action === 'add' && (
        <Modal title="Create supplier">
          <SupplierForm />
        </Modal>
      )}
    </>
  )
}

const ListWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>Suppliers list</PageTitle>
      <TableWrapper
        dataProvider={getSuppliers}
        cols={Columns}
        queryId="SUPPLIERS_LIST"
        lookup={{placeholder: 'Search Supplier'}}
        buttons={buttons}
        modals={SupplierModalWrapper}
        filters={{
          formFields: FilterForm,
          initialValues: initialFilters
        }}
      />
    </>
  )
}

export default ListWrapper
